export function DeviceDetailPage() {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-4">Device Details</h1>
      <p className="text-gray-600">Device details coming soon...</p>
    </div>
  )
}
